import { selectMenuBackdropProps } from "@config/theme/formControls";
import { menuPaperSx } from "./Select.styles";

export const createMenuProps = (maxHeight: number) => ({
  BackdropProps: selectMenuBackdropProps,
  PaperProps: {
    sx: {
      ...menuPaperSx,
      maxHeight: maxHeight,
      // Override any green background styling
      backgroundColor: "white",
      fontFamily: "Poppins, sans-serif",
      "& .MuiMenuItem-root": {
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: "var(--tvet-secondary, #e1f0f5)",
          color: "var(--tvet-secondary-foreground, #006d70)",
        },
        "&.Mui-selected": {
          backgroundColor: "var(--tvet-primary, #2a9699)",
          color: "var(--tvet-primary-foreground, #ffffff)",
          "&:hover": {
            backgroundColor: "var(--tvet-primary-hover, #248a8c)",
            color: "var(--tvet-primary-foreground, #ffffff)",
          },
        },
      },
    },
  },
});

export const placeholderStyles = {
  color: "#98A2B3",
}; 